import api from '@/api/api.js'
import api_config from '@/api/config/_api_config'

// RDV-002 : capacité signée « rendez-vous:manage » (120 s) demandée à be_config (rôle actif : Accueil, Caisse…),
// puis be_clinique avec l'en-tête. Seuls les appels déjà porteurs de la capacité courte sont « scoped » : un 401
// pendant son émission doit encore vérifier la session Config, sinon l'écran reste connecté avec un jeton expiré.
const options = token => ({ med_access_scoped: true, timeout: 20000, headers: { 'X-Rendez-Vous-Access': token } })
const accessOptions = () => ({ rendez_vous_access_request: true, timeout: 20000 })

export default {
    async access() {
        const response = await api_config().post('/rendez-vous/access', {}, accessOptions())
        if (!response.data.success || !response.data.data || !response.data.data.access_token) throw new Error('Accès aux rendez-vous indisponible.')
        return response.data.data
    },
    referentiel(token) {
        return api.clinique().get('/rendez-vous/referentiel', options(token)).then(response => response.data)
    },
    prochainPatient(patient_id, token) {
        return api.clinique().post('/rendez-vous/patient', { patient_id: patient_id }, options(token)).then(response => response.data)
    },
    liste(data, token) {
        return api.clinique().post('/rendez-vous/liste', data, options(token)).then(response => response.data)
    },
    creer(data, token) {
        return api.clinique().post('/rendez-vous', data, options(token)).then(response => response.data)
    },
    statut(rendez_vous_id, data, token) {
        return api.clinique().post('/rendez-vous/' + rendez_vous_id + '/statut', data, options(token)).then(response => response.data)
    },
    reprogrammer(rendez_vous_id, data, token) {
        return api.clinique().post('/rendez-vous/' + rendez_vous_id + '/reprogrammer', data, options(token)).then(response => response.data)
    },
    rappelsListe(data, token) {
        return api.clinique().post('/rendez-vous/rappels/liste', data, options(token)).then(response => response.data)
    },
    enregistrerRappel(rendez_vous_id, data, token) {
        return api.clinique().post('/rendez-vous/' + rendez_vous_id + '/rappels', data, options(token)).then(response => response.data)
    },
    // RDV-005 : indicateurs du mois (tous les médecins ou un seul)
    indicateurs(data, token) {
        return api.clinique().post('/rendez-vous/indicateurs', data, options(token)).then(response => response.data)
    },
    // RDV-006 : l'Accueil fixe l'heure d'un rendez-vous donné sans heure par le médecin ({ rendez_vous_id, heure: 'HH:MM' })
    fixerHeure(data, token) {
        return api.clinique().post('/rendez-vous/heure', data, options(token)).then(response => response.data)
    },
    // Demandes de rendez-vous des sites des clients Clinicaa (04/10/2026) : liste, patients à rattacher, traitement
    demandesSites(params, token) {
        return api.clinique().get('/rendez-vous/demandes-web', { ...options(token), params }).then(response => response.data)
    },
    patientsDemandeSite(search, token) {
        return api.clinique().get('/rendez-vous/demandes-web/patients', { ...options(token), params: { search } }).then(response => response.data)
    },
    traiterDemandeSite(id, data, token) {
        return api.clinique().post('/rendez-vous/demandes-web/' + id + '/traiter', data, options(token)).then(response => response.data)
    }
}
